import Header from "../components/Header";
import "../styles/Chat.css";

function Chat() {
  return (
    <div className="page">
      <Header />
      <div className="content">여기에 해당 페이지 작업해주시면 됩니다.</div>
    </div>
  );
}

export default Chat;
